import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogTitle } from '@mui/material';
import styled from 'styled-components';

const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 65px;

  & button {
    min-width: 8rem;
  }

  &.centered {
    justify-content: center;
  }
`;

/** Warning!: do not add 100vh to this component otherwise it will overlap the header bar on mobile devices and part of the component will be cut off */
export const StyledDialog = styled(Dialog) <{ $isFullHeight: boolean; $hasOverflowY?: boolean; $isAlignTop?: boolean; }>`
  display: flex;
  flex: 1;
  flex-direction: column;  

  & .MuiPaper-root {
    ${props => props.$hasOverflowY && `overflow-y: visible;`}    
    ${props => props.$isAlignTop && `position: absolute; top: 0;`}    
  }

  & .MuiDialog-container.MuiDialog-scrollPaper > .MuiPaper-root {
    ${props => props.theme.breakpoints.up('sm')} {
      ${props => props.$isFullHeight && `height:  90vh;`}
    }
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
  display: flex;
  justify-content: space-between;
  padding-left: ${props => props.theme.spacing(2)};
  padding-top: ${props => props.theme.spacing(1)};
  padding-bottom: ${props => props.theme.spacing(1)};
  padding-right: ${props => props.theme.spacing(0.5)};
  width: 100%;
  align-items: center;

  & h2 {
    display: flex;
    justify-content: space-between;
    flex: 1;
    align-items: center;
  }
`;

export { StyledDialogActions };
